import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import { Select } from 'hb-react/shared/components/formik/components/inputs';

const SelectAddress = ({ name, currentUser, setSelectedAddress }) => {
  const [address, setAddress] = useState('personal');

  const {
    currentNetwork: { user_fields_config: userFieldsConfig },
  } = useDefaultAppContexts();

  useEffect(() => {
    const selectedAddress = currentUser?.postal_address?.[address];

    if (selectedAddress) {
      setSelectedAddress(
        Object.entries(selectedAddress).reduce(
          (attributes, [attribute, value]) => ({
            ...attributes,
            [attribute]: value === null ? '' : value,
          }),
          {
            postal_address_type: address,
          },
        ),
      );
    }
  }, [address, currentUser]);

  const selectAddressOptions = {
    personal:
      userFieldsConfig?.postal_personal_label ||
      I18n.t('web.networks.events.receipt.billing_location.postal_address'),
    work:
      userFieldsConfig?.postal_work_label ||
      I18n.t('web.networks.events.receipt.billing_location.work_address'),
  };

  return (
    <Select
      name={name}
      options={selectAddressOptions}
      placeholder={__('Select address')}
      label={__('Choose address')}
      onChange={({ value }) => setAddress(value)}
      autoComplete="disabled"
      isNotSearchable
    />
  );
};

SelectAddress.propTypes = {
  currentUser: PropTypes.shape({
    postal_address: PropTypes.objectOf(
      PropTypes.shape({
        address_1: PropTypes.string,
        address_2: PropTypes.string,
        address_3: PropTypes.string,
        country: PropTypes.string,
        city: PropTypes.string,
        postal_code: PropTypes.string,
        state: PropTypes.string,
      }),
    ),
  }).isRequired,
  setSelectedAddress: PropTypes.func.isRequired,
};

export default SelectAddress;
